import React, { useEffect, useState } from 'react';
import {
  getOrganizations,
  postInquire,
} from '../Services/ShoppingList.service';
import { useSelector } from 'react-redux';
import { boolean, object, string } from 'yup';
import { translate } from '../Services/translation';
import InputCheckbox from './InputCheckbox';
import InputRadio from './InputRadio';
import InputTextArea from './InputTextArea';
import { googleAnalytics } from '../Services/googleAnalytics';

const formValidationSchema = object().shape({
  selectedStore: string()
    .required(translate(`validation.required`))
    .notOneOf(['none'], translate(`validation.required`)),
  name: string().required(translate(`validation.required`)),
  email: string().required(translate(`validation.required`)),
  phone: string().required(translate(`validation.required`)),
  isTosAccepted: boolean()
    .required(translate(`validation.checkrequired`))
    .oneOf([true], translate(`validation.checkrequired`))
});

const ShoppingListForm = ({ channelId, pageId, information, tosText, accessGroups, totalPrice }) => {
  const [organizations, setOrganizations] = useState([]);
  const [selectedCity, setSelectedCity] = useState('none');
  const [selectedStore, setSelectedStore] = useState('none');
  const [name, setName] = useState(null);
  const [email, setEmail] = useState(null);
  const [phone, setPhone] = useState(null);
  const [contactViaPhone, setContactViaPhone] = useState(false);
  const [contactViaEmail, setContactViaEmail] = useState(false);
  const [inquiryType, setInquiryType] = useState('price');
  const [message, setMessage] = useState('');
  const [isTosAccepted, setHasTosAccepted] = useState(false);
  const shoppingList = useSelector((x) => x.shoppingList);
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [showErrorMessage, setShowErrorMessage] = useState(false);

  useEffect(() => {
    let preffObject;
    const setup = async () => {
      if (shoppingList.length > 0) {
        setOrganizations(await getOrganizations(channelId));
        if(preffObject != null){
          setSelectedCity(preffObject.city)
          setSelectedStore(preffObject.shopName+`[${preffObject.streetName}]`)
        }
    }
  };
  try{
    const preff = localStorage.getItem('preferedaddress');
    preffObject = JSON.parse(preff)
  }catch(error){

  }finally{
    setup();
  }
  }, []);

  const hasAccess = (arr, target) => target && target.every(v => arr && arr.includes(v));

  const onChosenCity = (ev) => {
    setSelectedCity(ev.target.value);
    setSelectedStore('none');
  };

  const enableSubmit = () => {
      return selectedStore !== 'none'
  }

  const onSubmit = async (ev) => {
    ev.preventDefault();
    try {
      let res = await formValidationSchema.validate({
        name,
        phone,
        email,
        contactViaPhone,
        contactViaEmail,
        inquiryType,
        message,
        isTosAccepted,
        selectedStore,
        channelId,
        pageId,
      });
      res = { ...res, rows: shoppingList };
      if (await postInquire(res)) {
        setShowSuccessMessage(true);
        googleAnalytics({
          'event': 'sendWishlist',
          'resellerCity': selectedCity,
          'reseller_id': organizations
          .find((x) => x.city == selectedCity)
          ?.organizations.find(x => x.id == selectedStore)?.dealerERPID,
          'reseller': organizations
          .find((x) => x.city == selectedCity)
          ?.organizations.find(x => x.id == selectedStore)?.shopName,
          'email_contact': contactViaEmail, 
          'telephone_contact': contactViaPhone,
          'offerRequestType': inquiryType, 
          'value': totalPrice
        })
        setSelectedCity('none')
        setSelectedStore('none')
        setTimeout(() => {
          setShowSuccessMessage(false);
        }, 5000);
      } else {
        setShowErrorMessage(true);
        setTimeout(() => {
          setShowErrorMessage(false);
        }, 5000);
      }
    } catch (e) {
      setShowErrorMessage(true);
      setTimeout(() => {
        setShowErrorMessage(false);
      }, 5000);
    }
  };

  return (
    <form onSubmit={onSubmit}>
      <div className="row shoppinglist__addresses">
        <div
          className="columns small-12 medium-6 large-4"
          dangerouslySetInnerHTML={{ __html: information }}
        ></div>
        <div className="columns small-12 medium-6 large-4">
          <div className="form__inputGroup">
            <select
              className="form__input"
              onChange={onChosenCity}
              value={selectedCity}
              aria-label={translate('shoppinglist.selectcity')}
            >
              <option disabled value="none">
                {translate('shoppinglist.selectcity')}
              </option>
              {organizations.filter(o => o.organizations && o.organizations.some(oo => hasAccess(oo.accessGroups, accessGroups))).map((x) => (
                <option key={x.city} value={x.city}>
                  {x.city}
                </option>
              ))}
            </select>
          </div>
          <div className="form__inputGroup">
            <select
              className="form__input"
              onChange={(ev) => setSelectedStore(ev.target.value)}
              value={selectedStore}
              aria-label={translate('shoppinglist.selectstore')}
            >
              <option disabled value="none">
                {translate('shoppinglist.selectstore')}
              </option>
              {organizations
                .find((x) => x.city == selectedCity)
                ?.organizations.filter(o => hasAccess(o.accessGroups, accessGroups)).map((x) => (
                  <option key={x.id} value={x.id}>
                    {x.shopName}
                  </option>
                ))}
            </select>
          </div>
          <div className="form__inputGroup">
            <input
              className="form__input"
              placeholder={translate('shoppinglist.yourname')}
              aria-label={translate('shoppinglist.yourname')}
              onChange={(ev) => setName(ev.target.value)}
            />
          </div>
          <div className="form__inputGroup">
            <input
              className="form__input"
              placeholder={translate('shoppinglist.youremail')}
              aria-label={translate('shoppinglist.youremail')}
              type="email"
              required
              onChange={(ev) => setEmail(ev.target.value)}
            />
          </div>
          <div className="form__inputGroup">
            <input
              className="form__input"
              placeholder={translate('shoppinglist.yourphone')}
              aria-label={translate('shoppinglist.yourphone')}
              type="tel"
              required
              onChange={(ev) => setPhone(ev.target.value)}
            />
          </div>
        </div>
        <div className="columns small-12 medium-6 large-4">
          <div className="form__inputGroup">
            <p>{translate('shoppinglist.wanttobecontactedvia')}</p>
            <div className="shoppinglist__addresses--contact">
              <InputCheckbox
                name="contactViaEmail"
                title={translate('shoppinglist.email')}
                className="contact-check"
                onChange={(ev) => setContactViaEmail(ev.target.value == 'on')}
              />
              <InputCheckbox
                name="contactViaPhone"
                title={translate('shoppinglist.phone')}
                className="contact-check"
                onChange={(ev) => setContactViaPhone(ev.target.value == 'on')}
              />
            </div>
          </div>
          <fieldset className="form__inputGroup">
            <legend>
              {translate('shoppinglist.whattypeofinquery')}
            </legend>
            <div className="shoppinglist__addresses--type">
                <div className="lists">
                  <InputRadio
                    name="inquiryType"
                    title={translate('shoppinglist.price')}
                    value="price"
                    onChange={(ev) => setInquiryType(ev.target.value)}
                    checked={inquiryType === 'price'}
                  />
                </div>
                <div className="lists">
                  <InputRadio
                    name="inquiryType"
                    title={translate('shoppinglist.service')}
                    value="service"
                    onChange={(ev) => setInquiryType(ev.target.value)}
                    checked={inquiryType === 'service'}
                  />
                </div>
                <div className="lists">
                  <InputRadio
                    name="inquiryType"
                    title={translate('shoppinglist.inventory')}
                    value="inventory"
                    onChange={(ev) => setInquiryType(ev.target.value)}
                    checked={inquiryType === 'inventory'}
                  />
                </div>
                <div className="lists">
                  <InputRadio
                    name="inquiryType"
                    title={translate('shoppinglist.other')}
                    value="other"
                    onChange={(ev) => setInquiryType(ev.target.value)}
                    checked={inquiryType === 'other'}
                  />
                </div>
            </div>
          </fieldset>
          <div className="form__inputGroup">
            <InputTextArea
              placeholder={translate('shoppinglist.messagetocustomerservice')}
              aria-label={translate('shoppinglist.messagetocustomerservice')}
              onChange={(ev) => setMessage(ev.target.value)}
            />
          </div>
          <div className="form__inputGroup">
            <div className="input-wrapper">
              <InputCheckbox
                name="approveIntegrityPolicy"
                htmlTitle={tosText}
                onChange={() => { setHasTosAccepted(!isTosAccepted); }}
              />
            </div>
          </div>
          <button className={`shoppinglist__submit ${!enableSubmit() && 'disabled'}`} type="submit">
            {translate('shoppinglist.send')}
          </button>
          {showSuccessMessage && (
            <p>{translate('shoppinglist.submitsuccess')}</p>
          )}
          {showErrorMessage && <p>{translate('shoppinglist.submiterror')}</p>}
        </div>
      </div>
    </form>
  );
};

export default ShoppingListForm;